import { TAX_LIST_PAGE_RECEIVE, TAX_LIST_PAGE_ERROR, TAX_ITEM_DATA } from "../Constans"
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: [],
    taxItemData: {}
}

export const TaxListPageReducer = (state = defaultState, action) => {
    switch (action.type) {
        case TAX_LIST_PAGE_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case TAX_LIST_PAGE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        case TAX_ITEM_DATA:
            return {
                ...state,
                taxItemData: action.payload
            };
        default:
            return state;
    }
}